if (!window.qudeCardScriptLoaded) {
  window.qudeCardScriptLoaded = true;

  function updateRecoCardMedia(card, swatchLink) {
    if (!card || !swatchLink) return;
    const sliderEl = card.querySelector('product-card-slider');
    if (!sliderEl) return;

    const slideIndexRaw = swatchLink.dataset.variantSlideIndex;
    const slideIndex = slideIndexRaw === '' || slideIndexRaw == null ? null : Number(slideIndexRaw);
    const variantMediaId = swatchLink.dataset.variantMediaId;
    const variantMediaSrc = swatchLink.dataset.variantMediaSrc;

    const slides = Array.from(sliderEl.querySelectorAll('.keen-slider__slide'));
    const idMatchIndex =
      variantMediaId && slides.length
        ? slides.findIndex((s) => String(s.dataset.mediaId || '') === String(variantMediaId))
        : -1;

    const targetIndex =
      Number.isFinite(slideIndex) ? slideIndex : idMatchIndex >= 0 ? idMatchIndex : null;

    if (targetIndex != null) {
      sliderEl.dataset.startIndex = String(targetIndex);
      if (sliderEl.slider && typeof sliderEl.slider.moveToIdx === 'function') {
        sliderEl.slider.moveToIdx(targetIndex);
      }
      return;
    }

    if (variantMediaSrc) {
      const firstImg = sliderEl.querySelector('.keen-slider__slide img');
      if (firstImg) {
        firstImg.src = variantMediaSrc;
        firstImg.removeAttribute('srcset');
      }
    }
  }

  function initRecoCardDefaults(root) {
    const scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('[data-reco-card], .reco-card').forEach((card) => {
      if (card.dataset.recoDefaultInit === 'true') return;

      const form = card.querySelector('form[data-type="add-to-cart-form"]');
      const input = form ? form.querySelector('input[name="id"]') : null;
      if (!input || (!input.disabled && input.value)) return;

      const swatches = Array.from(card.querySelectorAll('.color-swatches__link'));
      if (!swatches.length) return;

      const firstAvailable = swatches.find((s) => s.dataset.variantAvailable !== 'false') || swatches[0];
      const variantId = firstAvailable?.dataset?.variantId;
      if (!variantId) return;

      updateRecoCardMedia(card, firstAvailable);

      input.value = variantId;
      input.disabled = false;

      swatches.forEach((s) => {
        s.classList.toggle('active', s === firstAvailable);
        s.classList.remove('tooltip-visible');
      });

      const shadeTextNode = firstAvailable.querySelector('.visually-hidden');
      const shadeText = shadeTextNode ? String(shadeTextNode.textContent || '').trim() : '';

      const shadeNameEl = card.querySelector('[data-reco-shade-name]');
      if (shadeNameEl) {
        if (typeof window.__formatRecoDashTitleHtml === 'function' && shadeText) {
          shadeNameEl.innerHTML = window.__formatRecoDashTitleHtml(shadeText);
        } else {
          shadeNameEl.textContent = shadeText || 'Farbe wählen';
        }
      }

      const shadeErrorEl = card.querySelector('[data-reco-shade-error]');
      if (shadeErrorEl) shadeErrorEl.classList.remove('visible');

      const recoAddBtn = card.querySelector('.reco-add-btn');
      if (recoAddBtn) {
        recoAddBtn.classList.add('ready');
        recoAddBtn.classList.remove('needs-shade');
      }

      card.dataset.recoDefaultInit = 'true';
    });
  }

  function initqudeCards() {
    if (!document.body) return;

    if (window.qudeCardsInitialized) {
      initRecoCardDefaults(document);
      return;
    }

    const escapeHtml = (value) => {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    };

    const titleCase = (value) => {
      return String(value || '')
        .split(' ')
        .filter(Boolean)
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
        .join(' ');
    };

    const cleanOptionValue = (raw) => {
      const str = String(raw || '').trim();
      if (!str) return '';
      if (str.includes('#')) {
        if (str.includes(',')) return String(str.split(',').slice(-1)[0] || '').trim();
        const parts = str.split(' ');
        parts.shift();
        return String(parts.join(' ') || '').trim();
      }
      return str;
    };

    const formatDashTitleHtml = (rawValue) => {
      const raw = cleanOptionValue(rawValue);
      if (!raw) return '';

      let leftPart = raw;
      let rightPart = '';

      const splitOn = (() => {
        const candidates = [' - ', ' – ', ' — ', '—', '–'];
        for (const c of candidates) {
          if (raw.includes(c)) return c;
        }
        return null;
      })();

      if (splitOn) {
        const idx = raw.indexOf(splitOn);
        leftPart = raw.slice(0, idx);
        rightPart = raw.slice(idx + splitOn.length);
      }

      const left = String(leftPart || '').trim();
      const right = String(rightPart || '').trim();
      const leftHtml = `<strong>${escapeHtml(left)}</strong>`;
      if (!right) return leftHtml;
      return `${leftHtml} – ${escapeHtml(right)}`;
    };

    window.__formatRecoDashTitleHtml = formatDashTitleHtml;

    initRecoCardDefaults(document);
    window.qudeCardsInitialized = true;

    const setRecoSelectedName = (card, rawLabel) => {
      const el = card ? card.querySelector('[data-reco-shade-name]') : null;
      if (!el) return;
      if (!rawLabel) {
        el.textContent = 'Farbe wählen';
        return;
      }
      el.innerHTML = formatDashTitleHtml(rawLabel);
    };

    const clearRecoError = (card) => {
      const err = card ? card.querySelector('[data-reco-shade-error]') : null;
      if (err) err.classList.remove('visible');
    };

    const markRecoReady = (card, isReady) => {
      const btn = card ? card.querySelector('.reco-add-btn') : null;
      if (!btn) return;
      btn.classList.toggle('ready', !!isReady);
      btn.classList.toggle('needs-shade', !isReady);
    };

    document.body.addEventListener('click', function (e) {
      const swatchLink = e.target.closest('.color-swatches__link');
      if (swatchLink) {
        e.preventDefault();
        e.stopPropagation();
        const card = swatchLink.closest('[data-reco-card], .reco-card, .card-qude');
        if (!card) return;

        const variantId = swatchLink.dataset.variantId;
        const isAvailable = swatchLink.dataset.variantAvailable !== 'false';

        if (!isAvailable) return;

        updateRecoCardMedia(card, swatchLink);

        const form = card.querySelector('form[data-type="add-to-cart-form"]');
        if (form) {
          const input = form.querySelector('input[name="id"]');
          if (input) {
            input.value = variantId;
            input.disabled = false;
          }
        }

        const allSwatches = card.querySelectorAll('.color-swatches__link');
        allSwatches.forEach((s) => {
          s.classList.toggle('active', s === swatchLink);
          s.classList.remove('tooltip-visible');
        });

        const shadeTextNode = swatchLink.querySelector('.visually-hidden');
        const shadeText = shadeTextNode ? String(shadeTextNode.textContent || '').trim() : '';
        setRecoSelectedName(card, shadeText);
        clearRecoError(card);
        markRecoReady(card, true);
        card.dataset.recoDefaultInit = 'true';

        const wrapper = card.querySelector('.card-qude__icon-wrapper');
        if (wrapper) {
          const tooltip = wrapper.querySelector('.card-qude__validation-msg');
          if (tooltip) {
            tooltip.classList.remove('active');
            if (tooltip.dataset.timeoutId) clearTimeout(tooltip.dataset.timeoutId);
          }
        }

        const btn = card.querySelector('.quick-add-submit-trigger');
        if (btn) {
          const textSpan = btn.querySelector('.card-qude__icon-text');
          if (textSpan && textSpan.dataset.originalText) {
            textSpan.textContent = textSpan.dataset.originalText;
          }
        }

        return;
      }

      const btn = e.target.closest('.quick-add-submit-trigger, .reco-add-btn');
      if (btn) {
        const form = btn.closest('form');
        const input = form ? form.querySelector('input[name="id"]') : null;

        if (input && (input.disabled || !input.value)) {
          const card = btn.closest('[data-reco-card], .reco-card, .card-qude');
          const isReco = card && (card.matches('.reco-card') || card.hasAttribute('data-reco-card'));

          if (isReco) {
            e.preventDefault();
            e.stopPropagation();

            const shadeErrorEl = card.querySelector('[data-reco-shade-error]');
            if (shadeErrorEl) shadeErrorEl.classList.add('visible');

            const shadeNameEl = card.querySelector('[data-reco-shade-name]');
            if (shadeNameEl && !String(shadeNameEl.textContent || '').trim()) {
              shadeNameEl.textContent = 'Farbe wählen';
            }

            btn.classList.add('needs-shade');
            btn.classList.remove('ready');
            return;
          }

          e.preventDefault();
          e.stopPropagation();

          const legacyCard = btn.closest('.card-qude');
          const swatchesContainer = legacyCard
            ? legacyCard.querySelector('.color-swatches')
            : null;
          const optionName = swatchesContainer ? swatchesContainer.dataset.optionName : 'Option';

          const wrapper = btn.closest('.card-qude__icon-wrapper');
          let tooltip = wrapper ? wrapper.querySelector('.card-qude__validation-msg') : null;

          if (!tooltip && wrapper) {
            tooltip = document.createElement('span');
            tooltip.className = 'card-qude__validation-msg';
            wrapper.appendChild(tooltip);
          }

          if (tooltip) {
            tooltip.textContent = `Please select ${optionName}`;
            tooltip.classList.add('active');

            if (tooltip.dataset.timeoutId) clearTimeout(tooltip.dataset.timeoutId);
            const timeoutId = setTimeout(() => {
              tooltip.classList.remove('active');
            }, 3000);
            tooltip.dataset.timeoutId = timeoutId;
          }
        }
      }

      const showMoreBtn = e.target.closest('.color-swatches__show-more-btn');
      if (showMoreBtn) {
        e.preventDefault();
        e.stopPropagation();
        const container = showMoreBtn.closest('.color-swatches__list');
        if (container) {
          container.querySelectorAll('.is-hidden').forEach((el) => {
            el.classList.remove('is-hidden');
          });
          const li = showMoreBtn.closest('li');
          if (li) li.remove();
        }
      }
    });

    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        m.addedNodes.forEach((node) => {
          if (!node || node.nodeType !== 1) return;
          initRecoCardDefaults(node);
        });
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', (e) => initRecoCardDefaults(e.target));
  }

  window.initqudeCards = initqudeCards;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initqudeCards);
  } else {
    initqudeCards();
  }
}
